RivalIQ.apps.CompanyProfile.module('views', function (views, App, Backbone, Marionette, $, _, companyDisplay, formats) {

    'use strict';

    views.Channel = RivalIQ.views.ItemView.mixin({
        getTemplate: function () {
            const me = this;
            return (me.hasChannel ? '#companyChannelTemplate' : '#companyProfileEmptyPresenceTemplate');
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            suggestModal: '.x-suggest-modal'
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        loadData: function () {
            const me = this;
            // TODO for the time being we must make cross-channel data requests,
            // because the channel name is not always representative of the
            // data we need to render the panel (e.g., Website)
            return RivalIQ.data.companyData.fetchCrossChannel(me.getProps())
                .done(function (companyData) {
                    me.model = new Backbone.Model(App.enums[me.getProp('channel')]);
                    me.companyRecord = companyData.get(me.getProp('companyId'));
                    me.hasChannel = me.companyRecord.hasChannel(me.model.get('source'));
                    me.companyData = companyData;
                });
        },

        templateHelpers: function () {
            const me = this;

            if (!me.hasChannel) {
                return {
                    icon: RivalIQ.enums.sourceDetails[me.model.get('source')].fontIcon
                };
            }

            const source = me.model.get('source');
            const details = RivalIQ.enums.sourceDetails[source];
            const record = me.companyRecord.getPrimaryRecord(source);

            const data = {
                handle: me.companyRecord.getDecoratedHandle(source),
                link: me.companyRecord.getLink(source),
                icon_url: record.presence.icon_url,
                overview: record.presence.overview
            };

            switch (source) {
                case RivalIQ.enums.sources.FACEBOOK:
                    _.extend(data, me.facebookData());
                    break;
                case RivalIQ.enums.sources.WEB:
                    _.extend(data, me.websiteData(record));
                    break;
                case RivalIQ.enums.sources.TWITTER:
                    data.icon_url = data.icon_url.replace(RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.TWITTER].lowResImgSuffix, '');
                    break;
                case RivalIQ.enums.sources.TIKTOK:
                    data.overview = data.overview || record.presence.signature;
                    break;
                default:
                    break;
            }

            let metrics = _.map(me.model.get('metrics'), function (metric) {
                const companyMetric = {
                    companyId: me.getProp('companyId')
                };
                if (_.isObject(metric)) {
                    _.extend(companyMetric, metric);
                } else {
                    _.extend(companyMetric, {
                        concept: metric
                    });
                }

                return companyMetric;
            });

            metrics = new RivalIQ.collections.Metrics(metrics, {
                companyData: me.companyData
            });

            return {
                isWebsite: (source === RivalIQ.enums.sources.WEB),
                details: details,
                data: data,
                metrics: metrics,
                formatter: RivalIQ.formatter,
                name: RivalIQ.enums.sourceDetails[me.model.get('source')].name,
                channel: me.getProp('channel'),
                icon: RivalIQ.enums.sourceDetails[me.model.get('source')].fontIcon,
                isExport: me.dashboardModel.isExporting(),
                hiddenYouTubeSubscriberCount: _.get(record, ['presence', 'hidden_subscriber_count'])
            };
        },

        facebookData: function () {
            const me = this;
            const data = {};
            const demographics = companyDisplay.getFacebookDemographics(me.companyRecord.toJSON());

            if (_.size(demographics)) {
                const likeCount = _.reduce(demographics, function (sum, v) {
                    return sum + v;
                }, 0);

                data.demographics = {
                    count: formats.number(likeCount)
                };
            }

            return data;
        },

        websiteData: function (record) {
            const data = {};

            if (record.presence.id) {
                data.icon_url = `/api/snapshotLatest?urlId=${record.presence.id}&imageSize=thumbnail`;
            }

            data.titleDesc = (record.presence.title === null || typeof record.presence.title === 'undefined' || (record.presence.title && record.presence.title.match(/^\s*$/)) ? '--' : record.presence.title);
            data.metaDesc = (record.presence.meta_description === null || typeof record.presence.meta_description === 'undefined' || (record.presence.meta_description && record.presence.meta_description.match(/^\s*$/)) ? '--' : record.presence.meta_description);

            return data;
        }
    });

}, RivalIQ.utils.companyDisplay, RivalIQ.formatter.formats);
